import { render } from "./Tabs_nav.vue?vue&type=template&id=68b993bc"
import script from "./Tabs_nav.vue?vue&type=script&lang=js"
export * from "./Tabs_nav.vue?vue&type=script&lang=js"

import "./Tabs_nav.vue?vue&type=style&index=0&id=68b993bc&lang=scss"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.3.1_vue@3.5.13_webpack@5.102.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"assets/js/mainapp/components/Tabs_nav.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "68b993bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('68b993bc', __exports__)) {
    api.reload('68b993bc', __exports__)
  }
  
  module.hot.accept("./Tabs_nav.vue?vue&type=template&id=68b993bc", () => {
    api.rerender('68b993bc', render)
  })

}


export default __exports__